"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Danger = function Danger(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,15.95A1,1,0,0,1,10.92,15V9.79a1.06,1.06,0,0,1,2.1,0V15A1,1,0,0,1,12,15.95Z",
    style: {
      fill: '#e5352b'
    }
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "11.97",
    cy: "18.08",
    r: "1.24",
    style: {
      fill: '#e5352b'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.88,20.94,15.25,6.74,12.58,2.17a.76.76,0,0,0-1.32,0L8.67,6.71,2,18,.11,21a.76.76,0,0,0,.66,1.16l22.47-.09a.76.76,0,0,0,.64-1.17ZM2.12,20.68,10, 7.48l1.94-3.39,2,3.43L21.86,20.6Z",
    style: {
      fill: '#014965'
    }
  }));
};

var _default = Danger;
exports["default"] = _default;